module.exports = __webpack_public_path__ + "img/50d.aa65b5f8.jpg";